"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ErrorPage_1 = require("./ErrorPage");
exports.ErrorPage = ErrorPage_1.default;
//# sourceMappingURL=index.js.map